/**
 *
 * Add .js class to body tag if JavaScript is enabled
 *
 * @since 1.0.0
 *
 */
document.getElementsByTagName( "body" )[0].className += " js";

(function( $ ) {

	$( document ).ready( function() {

		var $contents = $('.entry-content');
		if ( 0 < $contents.length ) {
			maybeAddContentToggle() ;
		}

		var $searchForm = $('.site-header .search-form');
		if ( 0 < $searchForm.length ) {

			$searchForm.attr( 'aria-hidden', 'true' );
			$searchForm.attr( 'id', 'header-search' );
			$searchForm.append( '<button class="search-close"><span class="screen-reader-text">Close Header Search</span></button>' );

			var $searchOpen  = $('.search-open > a');
			var $searchClose = $('.search-close');
			if ( 0 < $searchOpen.length && 0 < $searchClose.length ) {
				$searchOpen.attr( 'role', 'button' );
				$searchOpen.attr( 'aria-controls', 'header-search' );
				$searchClose.attr( 'aria-controls', 'header-search' );
				$searchOpen.on( 'click', openHeaderSearch );
				$searchClose.on( 'click', closeHeaderSearch );
			}

		}

		var $archiveList = $('.archive-list');
		if ( 0 < $archiveList.length ) {
			setupArchiveList();
		}

		function openHeaderSearch( e ) {
			e.preventDefault();
			$searchForm.find( 'input[type="search"]' ).focus();
			$searchForm.addClass( 'search-form--active' );
			$searchForm.attr( 'aria-hidden', 'false' );
		}

		function closeHeaderSearch( e ) {
			e.preventDefault();
			$searchOpen.focus();
			$searchForm.removeClass( 'search-form--active' );
			$searchForm.attr( 'aria-hidden', 'true' );
		}

		function maybeAddContentToggle() {
			if ( ! $contents ) {
				return false;
			}

			var $body = $('body');

			if ( ! $body.hasClass( 'single-post' ) && ! $body.hasClass( 'archive' ) ) {
				return false;
			}

			$.each( $contents, function( index, content ) {

				var $content = $(content);
				console.log($content );
				var totalHeight = $content.height();
				if ( totalHeight < 645 ) {
					return;
				}

				var $toggle  = $( '<button class="button" aria-expanded="false" aria-controls="truncated-content-' + index + '">Read Full Transcript</button>' );
				var original = $content.outerHeight();

				$content
					.addClass( 'truncated' )
					.attr( 'id', 'truncated-content-' + index )
					.css({ 'height': '645px'})
					.after( $toggle );

				$toggle.click( function() {
					if ( 'true' === $toggle.attr( 'aria-expanded' ) ) {
						$toggle
							.text( 'Read Full Transcript')
							.attr( 'aria-expanded', 'false' );
						$content
							.addClass( 'truncated' )
							.animate({
								height: '645px'
							});
					} else {
						$toggle
							.text( 'Hide Full Transcript')
							.attr( 'aria-expanded', 'true' );
						$content
							.removeClass( 'truncated' )
							.animate({
								height: original
							});
					}
				});
			});
		}

		function setupArchiveList() {

			$archiveList
				.find( '.archive-list__year__title' )
				.first()
				.addClass( 'archive-list__year__title--active' )
				.next( 'ul' )
				.attr( 'aria-hidden', 'false' )
				.slideDown();

			$archiveList.on( 'click', '.archive-list__year__title', function( e ) {
				e.preventDefault();
				var $this = $(this);
				var $next = $('#' + $this.attr( 'aria-controls' ) );

				if ( $this.hasClass( 'archive-list__year__title--active') ) {
					$this.removeClass( 'archive-list__year__title--active' );
					$this
						.next( 'ul' )
						.attr( 'aria-hidden', 'true' )
						.slideUp();
					return;
				}

				var $allLists = $archiveList.find( '.archive-list__year__title + ul' );
				$allLists.hide();
				$archiveList.find( '.archive-list__year__title' ).removeClass( 'archive-list__year__title--active' );
				$this.addClass('archive-list__year__title--active');
				$next
					.attr( 'aria-hidden', 'false' )
					.slideToggle( 200, function() {
						$('html,body').animate({
							scrollTop: $this.offset().top
						});
					});
			})
		}

	});

})(jQuery);
